var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"scroller scroll-snap",class:{ 'scroll-snap-active': _vm.centerPlansActive }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }